import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./page/index/index.module').then( m => m.IndexPageModule)
  },
  {
    path: 'login',
    loadChildren: () => import('./page/login/login.module').then( m => m.LoginPageModule)
  },
  {
    path: 'file',
    loadChildren: () => import('./page/file/file.module').then( m => m.FilePageModule)
  },
  {
    path: 'file/:parent_id',
    loadChildren: () => import('./page/file/file.module').then( m => m.FilePageModule)
  },
  {
    path: 'photo',
    loadChildren: () => import('./page/photo/photo.module').then( m => m.PhotoPageModule)
  },
  {
    path: 'movie',
    loadChildren: () => import('./page/movie/movie.module').then( m => m.MoviePageModule)
  },
  {
    path: 'favorite',
    loadChildren: () => import('./page/favorite/favorite.module').then( m => m.FavoritePageModule)
  },
  {
    path: 'favorite/:parent_id',
    loadChildren: () => import('./page/favorite/favorite.module').then( m => m.FavoritePageModule)
  },
  {
    path: 'trash',
    loadChildren: () => import('./page/trash/trash.module').then( m => m.TrashPageModule)
  },
  {
    path: 'trash/:parent_id',
    loadChildren: () => import('./page/trash/trash.module').then( m => m.TrashPageModule)
  },
  {
    path: 'profile',
    loadChildren: () => import('./page/profile/profile.module').then( m => m.ProfilePageModule)
  },
  {
    path: 'reminder',
    loadChildren: () => import('./page/reminder/reminder.module').then( m => m.ReminderPageModule)
  },
  {
    path: 'reminder/:reminder_key',
    loadChildren: () => import('./page/reminder/reminder.module').then( m => m.ReminderPageModule)
  },
  {
    path: 'approveemail/:email_key',
    loadChildren: () => import('./page/approveemail/approveemail.module').then( m => m.ApproveemailPageModule)
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
